<ion-item class="main-box" *ngFor="let itemFbDisponible of activeFB()">
  <ion-avatar item-left class="sportsFreebetBullet">
    <codere-style-money [amount]="itemFbDisponible?.Amount" [type]="0"></codere-style-money>
    <p>
      {{'fb' | translate}}
      <!--freebet-->
    </p>
  </ion-avatar>
  <div>
    <h2>
      {{itemFbDisponible.Name}}<span *ngIf="licenseType() === LicenseTypes.Colombia"
        >&nbsp;-&nbsp;COD:&nbsp;{{itemFbDisponible.VoucherCode}}</span
      >
    </h2>
    <h3>
      {{'importSlots' | translate}}
      <!--Importe-->
      <b>{{itemFbDisponible?.Amount | sportsParseMoney}}</b>
    </h3>
    <div *ngFor="let itemConditions of itemFbDisponible?.Conditions">
      <h3 *ngIf="itemConditions.ConditionValueDecimal > 0">
        {{'fb_txt_active6' | translate}}
        <b>{{itemConditions.ConditionValueDecimal | sportsFormatOdd}}</b>
      </h3>
      <h3 *ngIf="itemConditions.ConditionValueInt > 0">
        {{'fb_txt_active8' | translate}}
        <b>{{itemConditions.ConditionValueInt}}</b>
      </h3>
    </div>
    <h3 *ngIf="!itemFbDisponible?.IsRedeemable">
      {{'v2_ganaNetas' | translate}}
      <!--# Solo ganancias netas-->
    </h3>
  </div>
</ion-item>